import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./JobDetails.css";
import projectGalleryData from "../../data/projectgallery.json";
import Nav from "../Nav/Nav";
import JobSpecific from "../JobSpecific/JobSpecific";
import Footer from "../Footer/Footer";

const JobDetails = () => {
  const [project, setProject] = useState([]);

  useEffect(() => {
    if (projectGalleryData && projectGalleryData.length > 0) {
      const randomIndex = Math.floor(Math.random() * projectGalleryData.length);
      setProject(projectGalleryData[randomIndex]);
    }
  }, []);

  const { jobId } = useParams();
  const [isAlbanian, setIsAlbanian] = useState(() => {
    const savedLanguage = localStorage.getItem("language");
    return savedLanguage !== null ? JSON.parse(savedLanguage) : true;
  });

  const toggleLanguage = () => {
    setIsAlbanian((prev) => {
      const newLanguage = !prev;
      localStorage.setItem("language", JSON.stringify(newLanguage));
      return newLanguage;
    });
  };
  

  return (
    <>
      <div className="jobdetails-container-up">
        <Nav isAlbanian={isAlbanian} toggleLanguage={toggleLanguage} />
        <div className="jobdetails-container">
          <img
            src={project.gallery_image_url}
            alt="jobdetails-photo"
            className="jobdetails-image"
          />
          <div className="overlay">
            <div className="vertical-line left"></div>
            <div className="vertical-line right"></div>
            <div className="hero-title">
              <h1 className="overlay-text">
                {"  "}
                <strong>
                  <span class="protest-font"></span>
                  <img
                    src="/underlined2-1.png"
                    alt="Underline decoration"
                    className="underline-image"
                  />
                </strong>{" "}
              </h1>
            </div>
            <div className="bottom-line"></div>
          </div>
        </div>
        <JobSpecific
          jobId={parseInt(jobId, 10)}
          isAlbanian={isAlbanian}
        />
      </div>
      <Footer isAlbanian={isAlbanian} />
    </>
  );
};

export default JobDetails;
